export default __webpack_public_path__ + "static/elie-6e4e6296ee491c1b74c48b96d1783668.png";